'use strict';

import React from 'react';
import PropTypes  from 'prop-types';

const albumCoverThumbnail = props => (
  <button
    className="thumbnail_ album-cover"
    onClick={() => props.onSelect(props.file.album)}
    style={{backgroundImage: `url('${props.file.album.cover}')`}}
    aria-label={props.file.album.title}
  >
    <div className="caption text-truncate">
      {props.file.album.title}
    </div>
  </button>
);

albumCoverThumbnail.propTypes = {
  file: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default albumCoverThumbnail;
